module.exports = __webpack_public_path__ + "static/assets/img/educations_e.a69d46c2.svg";